<template>
    <v-container id="micaplp">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card dark color="success" class="alineacentro DatosMatriculado">
                    <strong>Mi CAPLP - AUTOGESTIÓN</strong>
                    <br/>
                    <strong class="TituloGrilla2">Bienvenido {{ matriculado.apenom }} - N° Mat: {{ matriculado.nromatricula}} </strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="5" lg="5">
                  <v-card class="alineacentro DatosMatriculado" min-height="200">
                    <v-card-title class="DatosMatriculado">
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-card dark color="info" class="alineacentro DatosMatriculado">
                            <strong>DATOS DE CONTACTO</strong>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text>
                      <v-row dense>
                        <v-col>
                          <v-spacer />
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDatoBold">
                          Domicilio Constituido:
                        </v-col>
                        <v-col cols="12" md="6" lg="6"  class="alineaizquierda TextoDato">
                          {{ matriculado.domicilioconstituido }}
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDatoBold">
                          Domicilio Real:
                        </v-col>
                        <v-col cols="12" md="6" lg="6"  class="alineaizquierda TextoDato">
                          {{ matriculado.domicilioreal }}
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDatoBold">
                          Teléfono:
                        </v-col>
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDato">
                          {{ matriculado.telefono }}
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDatoBold">
                          Celular:
                        </v-col>
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDato">
                          {{ matriculado.celular }}
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDatoBold">
                          Correo Electrónico:
                        </v-col>
                        <v-col cols="12" md="6" lg="6" class="alineaizquierda TextoDato">
                          {{ matriculado.correo }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-btn
                            class="ma-2"
                            x-small
                            color="blue"
                            title="Solicitar Cambio de Datos"
                            @click="solicitarcambiodatos"
                          >
                            <v-icon dark> mdi-text-box-edit</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="7" lg="7">
                  <v-card class="alineacentro DatosMatriculado" min-height="200">
                    <v-card-title class="DatosMatriculado">
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-card dark color="grey" class="alineacentro DatosMatriculado">
                            <strong>TÍTULOS</strong>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="columnasmatriculas"
                        :items="matriculado.listamatriculas"
                        :items-per-page="10"
                        :footer-props="{
                            'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text': 'Todos',
                        }"
                        item-key="idmatricula"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        hide-default-footer
                        disable-sort
                      >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="5" lg="5">
                  <v-card class="alineacentro DatosMatriculado" min-height="200">
                    <v-card-title class="DatosMatriculado">
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-card dark color="#a352eb" class="alineacentro DatosMatriculado">
                            <strong>ESPECIALIDADES</strong>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text>
                      <v-row class="text-center">
                        <v-col cols="12" class="alineaderecha">
                          <v-btn
                            class="ma-2"
                            x-small
                            color="#a352eb"
                            title="Agregar Especialidad"
                            @click="agregarespecialidad"
                          >
                            <v-icon dark> mdi-plus</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-data-table
                            :headers="columnasespecialidades"
                            :items="matriculado.listaespecialidades"
                            :items-per-page="10"
                            :footer-props="{
                                'items-per-page-text': 'Filas por Página:',
                                'items-per-page-all-text': 'Todos',
                            }"
                            item-key="idespecialidad"
                            class="elevation-1"
                            dense
                            no-data-text="Sin Registros"
                            hide-default-footer
                            disable-sort
                          >
                            <template v-slot:item.actions="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    x-small
                                    icon
                                    color="#a352eb"
                                    @click="quitarespecialidad(item)"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>Quitar</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-card class="alineacentro DatosMatriculado" min-height="200">
                    <v-card-title class="DatosMatriculado">
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-card dark :color="matriculado.deuda>0 ? 'red' : 'rgb(34, 190, 73)'" class="alineacentro DatosMatriculado">
                            <strong>SITUACIÓN DEUDA</strong>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text>
                      <p :class="matriculado.deuda>0 ? 'textoNegritaRojo' : 'textoNegritaVerde'">{{ matriculado.deudastr }}</p>
                      <p :class="matriculado.deuda>0 ? 'textoNegritaRojo' : 'textoNegritaVerde'">A la fecha {{ matriculado.deudafecha }}</p>
                      <v-btn
                        class="ma-2"
                        x-small
                        :color="matriculado.deuda>0 ? 'red' : 'rgb(34, 190, 73)'"
                        title="Ver Mas Información"
                        @click="dialogdeuda=true"
                        :disabled="matriculado.deudastr==='$ 0,00'"
                      >
                        <v-icon dark> mdi-magnify</v-icon>
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-card class="alineacentro DatosMatriculado" min-height="200">
                    <v-card-title class="DatosMatriculado">
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-card dark color="warning" class="alineacentro DatosMatriculado">
                            <strong>GESTIONES</strong>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text>
                      <v-row class="alineaizquierda" dense>
                        <v-col cols="12">
                          <v-btn
                            class="ma-2"
                            medium
                            color="warning"
                            title="Certificados de Matrícula"
                            @click="dialogcertificados=true"
                          >
                            <v-icon dark> mdi-certificate</v-icon> Certificados de Matrícula
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogdeuda" persistent max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Movimientos Pendientes del Matriculado {{ matriculado.apenom }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogdeuda = false"
                >
                    Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    :headers="columnasdeuda"
                    :items="matriculado.listadeuda"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idmovimiento"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Destinatarios"
                    multi-sort
                  >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogcertificados" persistent max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Certificados de Matrícula
          </v-card-title>
          <v-card-actions>
            <v-row row wrap>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                  class="ma-2"
                  x-small
                  color="green"
                  title="Nueva Solicitud"
                  @click="nuevasolicitudcertificado"
                >
                  <v-icon dark> mdi-plus</v-icon>
                  Nueva Solicitud
                </v-btn>
                <v-btn
                  x-small
                  color="red darken-1"
                  @click="dialogcertificados = false"
                >
                  Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    :headers="columnascertificados"
                    :items="matriculado.listacertificados"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idcertificado"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.estadocertificado="{ item }">
                      <v-chip :color="getColorCertificado(item.idestadocertificado)" dark>
                        <p class="textofilagrilla">{{ item.estadocertificado }}</p>
                      </v-chip>
                    </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevocertificado" persistent max-width="1024">
        <v-card>
          <v-card-title class="headline">Nueva Solicitud de Certificado</v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="solicitarcertificado">
                    Solicitar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevocertificado = false"
                    >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-container>
              <v-row class="text-center" v-if="matriculado.deuda>0">
                <v-col cols="12">
                  <p class="textoNegritaRojo">Deuda: {{ matriculado.deudastr }}</p>
                </v-col>
              </v-row>
              <v-row class="text-center" v-if="matriculado.deuda>0">
                <v-col cols="12">
                  <p class="textoNegritaRojo">Tiene deuda de Matrícula por saldar, el certificado si lo solicita quedará como pendiente con deuda hasta tanto resuelva su situación.</p>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-text-field
                      label="Para Presentar ante:"
                      v-model="certificado.ente"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogespecialidades" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Agregar Especialidad</v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="agregaespecialidad">
                    Agregar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogespecialidades = false"
                    >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-container>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="especialidad.idmatricula"
                    :items="listamatriculasespec"
                    label="Título"
                    item-text="tipotitulo"
                    item-value="idmatricula"
                    height="20px"
                    :no-data-text="'Sin elementos'"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="especialidad.idtipoespecialidad"
                    :items="listaespecialidades"
                    label="Especialidad"
                    item-text="nombre"
                    item-value="idtipoespecialidad"
                    height="20px"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogcambiodatos" persistent max-width="1200">
        <v-card>
          <v-card-title class="headline">Cambio de Datos para el Matriculado {{ matriculado.apenom }}</v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarcambios">
                    Cambiar Datos
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogcambiodatos = false"
                    >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-container>
              <v-card>
                <v-card-title class="TituloGrilla">Domicilio Constituido</v-card-title>
                <v-card-text>
                  <br />
                  <v-row row wrap class="text-center">
                    <v-col cols="12" md="6" lg="6">
                      <v-text-field
                        v-model="editadatos.domicilioconstituido"
                        label="Domicilio Constituido"
                        height="20px"
                      />
                    </v-col>
                  </v-row>
                  <v-row row wrap class="text-center">
                    <v-col cols="12" md="9" lg="9">
                      <selector-localidad3 :idlocinicial="editadatos.idlocalidadconstituido" :idprovinicial="editadatos.idprovinciaconstituido" :iddeptoinicial="editadatos.iddeptoconstituido" @selLocalidad="asignalocalidaddomicilioconstituido" ref="locconstituido"></selector-localidad3>
                    </v-col>
                    <v-col cols="12" md="3" lg="3">
                      <v-text-field
                        v-model="editadatos.codpostalconstituido"
                        label="Cod Postal"
                        height="20px"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card>
                <v-card-title class="TituloGrilla">Domicilio Real</v-card-title>
                <v-card-text>
                  <br />
                  <v-row row wrap class="text-center">
                    <v-col cols="12" md="6" lg="6">
                      <v-text-field
                        v-model="editadatos.domicilioreal"
                        label="Domicilio Real"
                        height="20px"
                      />
                    </v-col>
                  </v-row>
                  <v-row row wrap class="text-center">
                    <v-col cols="12" md="9" lg="9">
                      <selector-localidad3 :idlocinicial="editadatos.idlocalidadreal" :idprovinicial="editadatos.idprovinciareal" :iddeptoinicial="editadatos.iddeptoreal" @selLocalidad="asignalocalidaddomicilioreal" ref="locreal"></selector-localidad3>
                    </v-col>
                    <v-col cols="12" md="3" lg="3">
                      <v-text-field
                        v-model="editadatos.codpostalreal"
                        label="Cod Postal"
                        height="20px"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-row row wrap class="text-center">
                <v-col cols="12">
                  <br />
                </v-col>
              </v-row>
              <v-row row wrap class="text-center">
                <v-col cols="12">
                  <v-row row wrap>
                    <v-col cols="12" class="alineaizquierda">
                      <v-btn class="ma-2" fab dark
                        x-small
                        color="primary"
                        @click="newTelefono"
                      >
                        <v-icon dark>
                          mdi-phone-plus
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-data-table
                        :headers="columnastelefonos"
                        :items="editadatos.telefono.filter(c=> c.accion!='D')"
                        :items-per-page="10"
                        :footer-props="{'items-per-page-text': 'Filas por Página:',
                                        'items-per-page-all-text' : 'Todos'}"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Teléfonos"
                        sort-by="['idtelefono']"
                        multi-sort
                      >
                      <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                icon
                                color="green"
                                @click="editTelefono(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-cellphone-text</v-icon>
                              </v-btn>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          &nbsp;
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                icon
                                color="red"
                                @click="delTelefono(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-cellphone-remove</v-icon>
                              </v-btn>
                            </template>
                            <span>Borrar</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    v-model="editadatos.telefono"
                    label="Teléfono Fijo"
                    height="20px"
                    hint="Teléfono (sin 0 ni guiones)"
                  />
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    v-model="editadatos.celular"
                    label="Celular"
                    height="20px"
                    hint="Celular (sin 0 ni guiones ni el 15)"
                  />
                </v-col> -->
              </v-row>
              <v-row row wrap class="text-center">
                <v-col cols="12">
                  <br />
                  <v-row row wrap>
                    <v-col cols="12" class="alineaizquierda">
                      <v-btn class="ma-2" fab dark
                        x-small
                        color="primary"
                        @click="newCorreo"
                      >
                        <v-icon dark>
                          mdi-email-plus
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-data-table
                        :headers="columnascorreos"
                        :items="editadatos.correo.filter(c=> c.accion!='D')"
                        :items-per-page="10"
                        :footer-props="{'items-per-page-text': 'Filas por Página:',
                                        'items-per-page-all-text' : 'Todos'}"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Correos"
                        sort-by="['idcorreo']"
                        multi-sort
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                icon
                                color="green"
                                @click="editCorreo(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-email-edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          &nbsp;
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                icon
                                color="red"
                                @click="delCorreo(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-email-remove</v-icon>
                              </v-btn>
                            </template>
                            <span>Borrar</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogabmtelefono" persistent width="500">
        <v-card>
          <v-card-title class="headline">
            {{ tituloabmtelefono }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                  color="green darken-1"
                  text
                  @click="GrabarTelefono"
                >
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialogabmtelefono = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12">
                <v-select
                  v-model="editedtelefono.idtipotelefono"
                  :items="listatipostelefonos"
                  label="Tipo"
                  item-text="nombre"
                  item-value="idtipotelefono"
                  class="ocupa50"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" sm="5" md="5">
                <v-text-field
                  v-model="editedtelefono.codigoarea"
                  label="Cod. Area"
                />
              </v-col>
              <v-col cols="12" sm="7" md="7" offset-xs0 offset-md1>
                <v-text-field
                  v-model="editedtelefono.numero"
                  label="Número"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogabmcorreo" persistent width="500">
        <v-card>
          <v-card-title class="headline">
            {{ tituloabmcorreo }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                  color="green darken-1"
                  text
                  @click="GrabarCorreo"
                >
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialogabmcorreo = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12">
                <v-text-field
                  v-model="editedcorreo.correo"
                  label="Correo"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorLocalidad3 from "../../components/SelectorLocalidad3.vue";
export default {
  name: "micaplp",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorLocalidad3
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 61,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      matriculado: {
        idpersona: 0,
        nromatricula: 0,
        nrodoc: '',
        apenom: '',
        domicilioconstituido: '',
        domicilioreal: '',
        telefono: '',
        celular: '',
        correo: '',
        listamatriculas: [],
        deudastr: '',
        deuda: 0.00,
        deudafecha: '',
        listadeuda: [],
        listacertificados: [],
        listaespecialidades: []
      },
      columnasmatriculas: [
        {
            text: "TyF",
            align: "center",
            value: "tyf",
            width: 80
        },
        {
            text: "Título",
            align: "center",
            value: "titulo",
            width: 110
        },
        {
            text: "F. Mat",
            align: "center",
            value: "fechamatricula",
            width: 85
        },
        {
            text: "F. Tít",
            align: "center",
            value: "fechatitulo",
            width: 85
        },
        {
            text: "Estado",
            align: "center",
            value: "estadomatricula",
            width: 90
        },
        {
            text: "Universidad",
            align: "center",
            value: "universidad",
            width: 110
        },
        {
            text: "Circ.",
            align: "center",
            value: "circunscripcion",
            width: 110
        },
        {
            text: "Radic",
            align: "center",
            value: "radicacion",
            width: 80
        },
        {
            text: "CF Act",
            align: "center",
            value: "numeroCajaForenseActivo",
            width: 90
        },
        {
            text: "CF Pas",
            align: "center",
            value: "numeroCajaForensePasivo",
            width: 90
        },
      ],
      columnasdeuda: [
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idmov",
            width: 60
        },
        {
            text: "Año",
            align: "center",
            sortable: true,
            value: "cuotaanual",
            width: 80
        },
        {
            text: "N° Cuota",
            align: "center",
            sortable: true,
            value: "cuotanro",
            width: 100
        },
        {
            text: "Detalle",
            align: "center",
            sortable: true,
            value: "detalle",
            width: 200
        },
        {
            text: "Vencim.",
            align: "center",
            sortable: true,
            value: "vencimiento",
            width: 110
        },
        {
            text: "Importe",
            align: "center",
            sortable: true,
            value: "importe",
            width: 110
        },
        {
            text: "Saldo",
            align: "center",
            sortable: true,
            value: "saldo",
            width: 110
        },
        {
            text: "Interes",
            align: "center",
            sortable: true,
            value: "interes",
            width: 120
        },
        {
            text: "Total",
            align: "center",
            sortable: true,
            value: "total",
            width: 120
        },
        {
            text: "Acumulado",
            align: "center",
            sortable: true,
            value: "acumulado",
            width: 120
        }
      ],
      dialogdeuda: false,
      dialogcertificados: false,
      columnascertificados: [
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idcertificado",
            width: 60
        },
        {
            text: "Fecha",
            align: "center",
            sortable: true,
            value: "fechasolicituddmy",
            width: 80
        },
        {
            text: "Ente Sol.",
            align: "center",
            sortable: true,
            value: "entesolicita",
            width: 100
        },
        {
            text: "Comentario",
            align: "center",
            sortable: true,
            value: "comentario",
            width: 180
        },
        {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estadocertificado",
            width: 100
        },
        {
            text: "Fec Estado",
            align: "center",
            sortable: true,
            value: "fechaestadodmy",
            width: 120
        }
      ],
      dialognuevocertificado: false,
      certificado: {
        idcertificado: 0,
        idpersona: 0,
        ente: '',
        comentario: '',
        idestado: 1,
        usuario: ''
      },
      columnasespecialidades: [
        {
            text: "Op.",
            value: "actions",
            width: 50
        },
        {
            text: "Título",
            align: "center",
            sortable: true,
            value: "tipotitulo",
            width: 80
        },
        {
            text: "Especialidad",
            align: "center",
            sortable: true,
            value: "tipoespecialidad",
            width: 200
        }
      ],
      dialogespecialidades: false,
      especialidad: {
        idpersona: 0,
        idmatricula: 0,
        idtipoespecialidad: 0,
        usuario: '',
        accion: 'A'
      },
      listaespecialidades: [],
      listamatriculasespec: [],
      dialogcambiodatos: false,
      editadatos: {
        idpersona: 0,
        iddomicilioconstituido: 0,
        domicilioconstituido: '',
        idlocalidadconstituido: 0,
        localidadconstituido: '',
        iddeptoconstituido: 0,
        deptoconstituido: '',
        idprovinciaconstituido: 0,
        provinciaconstituido: '',
        codpostalconstituido: '',
        iddomicilioreal: 0,
        domicilioreal: '',
        idlocalidadreal: 0,
        localidadreal: '',
        iddeptoreal: 0,
        deptoreal: '',
        idprovinciareal: 0,
        provinciareal: '',
        codpostalreal: '',
        telefono: [],
        correo: [],
        usuario: this.usuario
      },
      columnastelefonos: [
        {
            text: "Op.",
            value: "actions",
            width: 50
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "id",
            width: 80
        },
        {
            text: "Tipo",
            align: "center",
            sortable: true,
            value: "tipotelefono",
            width: 100
        },
        {
            text: "Cod Area",
            align: "center",
            sortable: true,
            value: "codigoarea",
            width: 110
        },
        {
            text: "Número",
            align: "center",
            sortable: true,
            value: "numero",
            width: 200
        }
      ],
      columnascorreos: [
        {
            text: "Op.",
            value: "actions",
            width: 50
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "id",
            width: 80
        },
        {
            text: "Correo",
            align: "center",
            sortable: true,
            value: "correo",
            width: 200
        }
      ],
      dialogabmtelefono: false,
      tituloabmtelefono: '',
      dialogabmcorreo: false,
      tituloabmcorreo: '',
      editedtelefono: {
        nuevo: false,
        id: 0,
        idtelefono: 0,
        idtipotelefono: 1,
        codigoarea: '',
        numero: '',
        accion: ''
      },
      listatipostelefonos: [],
      editedcorreo: {
        nuevo: false,
        id: 0,
        idcorreo: 0,
        correo: '',
        accion: ''
      }
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var idrol = localStorage.getItem("rolusuario");
    var roles= localStorage.getItem('rolesusuario')
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion===1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
      this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
      this.Inicio();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Inicio () {
      var filtro= JSON.stringify({ usuario: this.usuario });
      axios.post("autogestion/PostAutogestionInicio", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          if(result.data.datos.errordescripcion===null || (result.data.datos.errordescripcion!=null && result.data.datos.errordescripcion.length===0))
          {
            this.matriculado = result.data.datos;
            axios.get('tipotelefono').then((result) => {
              this.listatipostelefonos = result.data;
              this.loading = false;
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje('Error', error, false);
            })
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.datos.errordescripcion, true);
          }
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    nuevasolicitudcertificado () {
      if(this.matriculado.listacertificados.filter(c=> c.idestadocertificado===0 || c.idestadocertificado===1).length===0)
      {
        this.certificado= {
          idcertificado: 0,
          idpersona: this.matriculado.idpersona,
          ente: 'ANTE QUIEN CORRESPONDA.-',
          comentario: '',
          idestado: this.matriculado.deuda>0 ? 0 : 1,
          usuario: this.usuario
        };
        this.dialognuevocertificado=true;
      }else{
        this.MostrarMensaje("Error", 'No podrá solicitar un nuevo certificado mientras haya certificados pendientes de emitir', false);
      }
    },
    getColorCertificado (idestado) {
      if (idestado === 1) return "grey";
      else if (idestado === 2) return "green";
      else if (idestado === 3) return "blue";
      else if (idestado === 4) return "#5646db";
      else if (idestado === 5) return "black";
    },
    solicitarcertificado () {
      if(this.certificado.ente.length>0) {
        this.loading= true;
        const certificado = JSON.stringify(this.certificado);
        axios.post("certificado/PostCertificado", certificado, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevocertificado = false;
            this.Inicio();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.MostrarMensaje("Error", 'Debe ingresar que entidad la solicita', false);
      }
    },
    solicitarcambiodatos () {
      this.loading = true;
      var filtro= JSON.stringify({ idmatriculado: this.matriculado.idpersona, usuario: this.usuario });
      axios.post("autogestion/PostTraeDatosMatriculado", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.editadatos= {
            idpersona: this.matriculado.idpersona,
            iddomicilioconstituido: result.data.datos.iddomicilioconstituido,
            domicilioconstituido: result.data.datos.domicilioconstituido,
            idlocalidadconstituido: result.data.datos.idlocalidadconstituido,
            localidadconstituido: result.data.datos.localidadconstituido,
            iddeptoconstituido: result.data.datos.iddeptoconstituido,
            deptoconstituido: result.data.datos.deptoconstituido,
            idprovinciaconstituido: result.data.datos.idprovinciaconstituido,
            provinciaconstituido: result.data.datos.provinciaconstituido,
            codpostalconstituido: result.data.datos.codpostalconstituido,
            iddomicilioreal: result.data.datos.iddomicilioreal,
            domicilioreal: result.data.datos.domicilioreal,
            idlocalidadreal: result.data.datos.idlocalidadreal,
            localidadreal: result.data.datos.localidadreal,
            iddeptoreal: result.data.datos.iddeptoreal,
            deptoreal: result.data.datos.deptoreal,
            idprovinciareal: result.data.datos.idprovinciareal,
            provinciareal: result.data.datos.provinciareal,
            codpostalreal: result.data.datos.codpostalreal,
            telefono: result.data.datos.telefono,
            correo: result.data.datos.correo,
            usuario: this.usuario
          };
          this.dialogcambiodatos= true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    agregarespecialidad () {
      axios.get("referenciales/especialidades").then((result) => {
        var listaespec= result.data;
        var listaespecusadas= this.matriculado.listaespecialidades;
        let listaespsinusar = listaespec.filter(function(esp){
          if(listaespecusadas.filter(e=> e.idtipoespecialidad===esp.idtipoespecialidad).length===0){
            return esp;
          }
        });
        this.listaespecialidades= listaespsinusar;
        this.especialidad= {
          idpersona: this.matriculado.idpersona,
          idmatricula: this.matriculado.listamatriculas[0].idmatricula,
          idtipoespecialidad: 0,
          usuario: this.usuario,
          accion: 'A'
        };
        this.listamatriculasespec= this.matriculado.listamatriculas.slice();
        this.dialogespecialidades=true;
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      })
    },
    agregaespecialidad () {
      if(this.especialidad.idtipoespecialidad!=null && this.especialidad.idtipoespecialidad!=0) {
        this.loading= true;
        const espec = JSON.stringify(this.especialidad);
        axios.post("matriculado/PostEspecialidadMatricula", espec, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialogespecialidades = false;
            this.Inicio();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.MostrarMensaje("Error", 'Debe seleccionar una especialidad', false);
      }
    },
    async quitarespecialidad (item) {
      if (await this.$refs.confirm.open("Confirmar Borrado de Especialidad","Esta seguro de querer borrar la especialidad?")) {
        this.loading= true;
        this.especialidad= {
          idpersona: this.matriculado.idpersona,
          idmatricula: item.idmatricula,
          idtipoespecialidad: item.idtipoespecialidad,
          usuario: this.usuario,
          accion: 'B'
        };
        const espec = JSON.stringify(this.especialidad);
        axios.post("matriculado/PostEspecialidadMatricula", espec, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.Inicio();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    asignalocalidaddomicilioconstituido (value) {
      this.editadatos.idlocalidadconstituido= value!=null ? value.idlocalidad : 0
      this.editadatos.localidadconstituido= value!=null ? value.localidad : ''
      this.editadatos.iddeptoconstituido= value!=null ? value.iddepto : 0
      this.editadatos.deptoconstituido= value!=null ? value.depto : ''
      this.editadatos.idprovinciaconstituido= value!=null ? value.idprovincia : 0
      this.editadatos.provinciaconstituido= value!=null ? value.provincia : ''
    },
    asignalocalidaddomicilioreal (value) {
      this.editadatos.idlocalidadreal= value!=null ? value.idlocalidad : 0
      this.editadatos.localidadreal= value!=null ? value.localidad : ''
      this.editadatos.iddeptoreal= value!=null ? value.iddepto : 0
      this.editadatos.deptoreal= value!=null ? value.depto : ''
      this.editadatos.idprovinciareal= value!=null ? value.idprovincia : 0
      this.editadatos.provinciareal= value!=null ? value.provincia : ''
    },
    guardarcambios () {
      var filtro= JSON.stringify(this.editadatos);
      axios.post("autogestion/PostGuardarDatosContacto", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.dialogcambiodatos=false;
          this.Inicio();
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    newTelefono () {
      this.tituloabmtelefono= 'Nuevo Teléfono';
      this.editedtelefono= {
        nuevo: true,
        id: this.editadatos.telefono.length>0 ? this.editadatos.telefono.length+1 : 1,
        idtelefono: 0,
        idtipotelefono: 2,
        codigoarea: '',
        numero: '',
        accion: 'A'
      };
      this.dialogabmtelefono= true;
    },
    editTelefono (item) {
      this.tituloabmtelefono= 'Editando Teléfono';
      this.editedtelefono= {
        nuevo: false,
        id: item.id,
        idtelefono: item.idtelefono,
        idtipotelefono: item.idtipotelefono,
        codigoarea: item.codigoarea,
        numero: item.numero,
        accion: item.idcorreo===0 ? 'A' : 'M'
      };
      this.dialogabmtelefono= true;
    },
    async delTelefono (item) {
      if (await this.$refs.confirm.open('Confirmar Borrado', 'Esta seguro de querer borrar el teléfono?')) {
        //this.mat.listatelefonos.splice(this.mat.listatelefonos.indexOf(item), 1)
        item.accion='D'
      }
    },
    GrabarTelefono () {
      this.loading = true
      this.editedtelefono.tipotelefono = this.listatipostelefonos.filter(d => d.idtipotelefono === this.editedtelefono.idtipotelefono)[0].nombre
      if(this.editedtelefono.nuevo === true)
      {
        var newtel= { id: this.editedtelefono.id, idtelefono: this.editedtelefono.idtelefono, idtipotelefono: this.editedtelefono.idtipotelefono, tipotelefono: this.editedtelefono.tipotelefono, codigoarea: this.editedtelefono.codigoarea,numero: this.editedtelefono.numero, accion: this.editedtelefono.accion };
        this.editadatos.telefono.push(newtel);
      }else{
        var reg=this.editadatos.telefono.filter(d=> d.id === this.editedtelefono.id)[0];
        reg.idtipotelefono = this.editedtelefono.idtipotelefono;
        reg.tipotelefono = this.editedtelefono.tipotelefono;
        reg.codigoarea = this.editedtelefono.codigoarea;
        reg.numero = this.editedtelefono.numero;
        reg.accion = this.editedtelefono.accion;
      }
      this.loading = false;
      this.dialogabmtelefono = false;
    },
    newCorreo () {
      this.tituloabmcorreo= 'Nuevo Correo';
      this.editedcorreo= {
        nuevo: true,
        id: this.editadatos.correo.length>0 ? this.editadatos.correo.length+1 : 1,
        idcorreo: 0,
        correo: '',
        accion: 'A'
      };
      this.dialogabmcorreo= true;
    },
    editCorreo (item) {
      this.tituloabmcorreo= 'Editando Correo';
      this.editedcorreo= {
        nuevo: false,
        id: item.id,
        idcorreo: item.idcorreo,
        correo: item.correo,
        accion: item.idcorreo===0 ? 'A' : 'M'
      };
      this.dialogabmcorreo= true;
    },
    async delCorreo (item) {
      if (await this.$refs.confirm.open('Confirmar Borrado', 'Esta seguro de querer borrar el correo?')) {
        //this.mat.listacorreos.splice(this.mat.listacorreos.indexOf(item), 1)
        item.accion='D'
      }
    },
    GrabarCorreo () {
      this.loading = true
      if(this.editedcorreo.nuevo === true)
      {
        var newc= { id: this.editedcorreo.id, idtelefono: this.editedcorreo.idcorreo, correo: this.editedcorreo.correo, accion: this.editedcorreo.accion };
        this.editadatos.correo.push(newc);
      }else{
        var reg=this.editadatos.correo.filter(d=> d.id === this.editedcorreo.id)[0];
        reg.correo = this.editedcorreo.correo;
        reg.accion = this.editedcorreo.accion;
      }
      this.loading = false
      this.dialogabmcorreo = false
    }
},
  computed: {
    /* fechalocalfcon: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }, */
  },
};
</script>
<style>
.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.hide-toolbar .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
        display: none;
    }
}

.ql-font-roboto {
  font-family: 'Roboto', sans-serif;
}

.editor {
    height: 40rem;
    overflow: hidden;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa10 {
  width: 10%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TextoDatoBold {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
}
.TextoDato {
  font-family: Tahoma;
  font-size: medium;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkseagreen;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(34, 190, 73) !important;
  font-weight: bold !important;
}
</style>